import Database from 'database';
import api from 'api';
import moment from 'moment';
import Helpers from 'shared/helpers';

import { Creators as pemCreators } from './pems';
import { Creators as cidadesCreators } from './cidades';
import { Creators as culturasCreators } from './culturas';
import { Creators as estadosCreators } from './estados';
import { Creators as perguntasCreators } from './perguntas';
import { Creators as respostasCreators } from './respostas';
import { Creators as produtosCreators } from './produtos';
import { Creators as etapasCreators } from './etapas';

export const Types = {
  SYNC: 'syncs/SYNC',
  SYNC_SUCCESS: 'syncs/SYNC_SUCCESS',
  SYNC_FAILED: 'syncs/SYNC_FAILED',
  SYNC_STORE: 'syncs/SYNC_STORE',
  SYNC_STORE_SUCCESS: 'syncs/SYNC_STORE_SUCCESS',
  SYNC_STORE_FAILED: 'syncs/SYNC_STORE_FAILED',
  UPDATE_AVAILABLE: 'syncs/UPDATE_AVAILABLE',
};

const initialState = {
  loading: false,
  error: null,
  pems: null,
  perguntas: null,
  fases: null,
  dadosIniciais: null,
  cidades: null,
  estados: null,
  culturas: null,
  etapas: null,
  updateAvailable: false,
  syncStore: {
    loading: false,
    error: null,
  },
};

export default function SyncsReducer(state = initialState, action) {
  switch (action.type) {
    case Types.SYNC:
      return { ...state, loading: true };
    case Types.SYNC_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Types.SYNC_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    case Types.SYNC_STORE:
      return { ...state, syncStore: { ...state.syncStore, loading: true } };
    case Types.SYNC_STORE_SUCCESS:
      return { ...state, syncStore: { ...state.syncStore, loading: false } };
    case Types.UPDATE_AVAILABLE:
      return { ...state, updateAvailable: true };
    case Types.SYNC_STORE_FAILED:
      return {
        ...state,
        syncStore: { ...state.syncStore, error: action.payload.error },
      };
    default:
      return state;
  }
}

export const Creators = {
  syncStore: (reducers) => async (dispatch) => {
    try {
      dispatch({ type: Types.SYNC_STORE });
      await Helpers.asyncForEach(reducers, (reducer) => {
        switch (reducer) {
          case 'pems':
            dispatch(pemCreators.getPems());
            break;
          case 'cidades':
            dispatch(cidadesCreators.getCidades());
            break;
          case 'estados':
            dispatch(estadosCreators.getEstados());
            break;
          case 'culturas':
            dispatch(culturasCreators.getCulturas());
            break;
          case 'perguntas':
            dispatch(perguntasCreators.getPerguntas());
            break;
          case 'respostas':
            dispatch(respostasCreators.getRespostas());
            break;
          case 'produtos':
            dispatch(produtosCreators.getProdutos());
            break;
          case 'etapas':
            dispatch(etapasCreators.getEtapas());
            break;
          default:
            console.error(`${reducer} isn't a recognised reducer`);
        }
      });
      dispatch({ type: Types.SYNC_STORE_SUCCESS });
    } catch (woof) {
      dispatch({
        type: Types.SYNC_STORE_FAILED,
        payload: { error: woof.message },
      });
    }
  },
  sync: () => async (dispatch) => {
    dispatch({ type: Types.SYNC });
    try {
      /**
       * Remote to Local Sync
       */
      // find out if a sync is necessary
      const { data } = await api.get('/sync');
      const remoteSyncData = data || null;
      let syncItems = [];
      let localSyncData = await Database.syncs.toArray();
      if (!localSyncData.length || !remoteSyncData) {
        localSyncData = null;
        syncItems = [
          'pems',
          'perguntas',
          'respostas',
          'cidades',
          'estados',
          'produtos',
          'culturas',
          'etapas',
          'impactos',
        ];
      } else {
        localSyncData = localSyncData[localSyncData.length - 1];
        Object.keys(remoteSyncData).forEach((key) => {
          if (
            remoteSyncData[key] === undefined ||
            localSyncData[key] === undefined
          ) {
            return;
          }
          const remoteMoment = moment(remoteSyncData[key]);
          const localMoment = moment(localSyncData[key] || '0001-01-01');
          if (localMoment.isBefore(remoteMoment)) {
            syncItems.push(key);
          }
        });
      }

      // sync routine
      if (syncItems.length) {
        const now = moment();
        const updatedItems = [];
        await Helpers.asyncForEach(syncItems, async (syncItem) => {
          try {
            const response = await api.get(`/${syncItem}`);
            await Database[syncItem].clear();
            await Database[syncItem].bulkPut(response.data);
            updatedItems.push(syncItem);
          } catch (oof) {
            console.log(oof);
          }
        });

        const syncOutput = {};
        updatedItems.forEach((item) => {
          syncOutput[item] = now;
        });
        const response = await api.put('/sync', syncOutput);
        const curr = await Database.syncs.toCollection().first();
        await Database.syncs.put({ ...curr, ...response.data, etapas: null });
        dispatch({
          type: Types.SYNC_SUCCESS,
          payload: { ...response.data, etapas: null },
        });
      } else {
        dispatch({ type: Types.SYNC_SUCCESS, payload: {} });
      }
      dispatch(Creators.syncStore(syncItems));
    } catch (woof) {
      dispatch({
        type: Types.SYNC_FAILED,
        payload: { error: 'Falha na sincronização' },
      });
    }
  },
};
